import type { PanelItem } from '../types';

export class PanelsList {
  #list: PanelItem[] = [];

  push<Props>(panel: PanelItem<Props>) {
    this.#list.push(panel as PanelItem);
  }

  getAll() {
    return this.#list;
  }
}
